import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';

export default {
  methods: {
    shuffle(a) {
      if (a.length == 0) return;
      // for ( let i = a.length - 1; i > 0; i-- ) {
      //   const j = Math.floor( Math.random() * ( i + 1 ) );
      //   [ a[ i ], a[ j ] ] = [ a[ j ], a[ i ] ];
      // }
      return _.shuffle(a);
    },
    prototypeArray() {
      Array.prototype.max = function () {
        return Math.max.apply(null, this);
      };
      Array.prototype.move = function (element, offset) {
        let index = this.indexOf(element);
        let newIndex = index + offset;

        if (newIndex > -1 && newIndex < this.length) {
          let removedElement = this.splice(index, 1)[0];
          this.splice(newIndex, 0, removedElement);
        }
      };
    },
    setDataGame() {
      this.initData = this.startGameConfig;
      if (!Number.isInteger(this.initData.sampleBgr.pos.x)) this.initData.sampleBgr.pos.x = 0;
      if (!Number.isInteger(this.initData.sampleBgr.pos.y)) this.initData.sampleBgr.pos.y = 0;
      this.stage = new createjs.Stage('gameCanvas');
      this.stage.mouseMoveOutside = true;
      this.stage.snapToPixelEnabled = true;
      this.animation = this.startGameConfig.animation !== true ? false : true;
      this.ticker.framerate = 60;
      if (this.ticker.hasEventListener('tick')) this.ticker.removeAllEventListeners();
      this.ticker.addEventListener('tick', this.tick);
      this.ticker.paused = true;
    },
    setStage() {
      this.width = Number.isInteger(this.initData.width)
        ? this.initData.width
        : document.getElementById('game-container').offsetWidth;
      this.height = Number.isInteger(this.initData.height)
        ? this.initData.height
        : document.getElementById('game-container').offsetHeight;
      console.log(this.width + ' - ' + this.height);
      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };

      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;

      if (this.initData.canvasBgr) {
        let bgr = this.createContainer(this.initData.canvasBgr);
        bgr.name = 'canvas';
        bgr.x -= this.offset.x;
        bgr.y -= this.offset.y;
        this.stage.addChild(bgr);
      }

      this.line = new createjs.Shape();
      //   if (this.initData.hideLine) this.stage.addChild(this.line);
      this.clones = [];
      this.maxClone = Number.isInteger(this.initData.maxCloneNumber) ? this.initData.maxCloneNumber : 500;
    },
    UnCacheStage(flg) {
      var l = this.stage.numChildren - 1;
      for (var i = 0; i < l; i++) {
        var shape = this.stage.getChildAt(i);
        if (flg) shape.cache(-shape.width, -shape.height, shape.width * 2, shape.height * 2);
        else shape.uncache();
      }
    },
    createContainer(obj) {
      var container = new createjs.Container();
      container.x = obj.pos !== undefined && Number.isInteger(obj.pos.x) ? obj.pos.x : 0;
      container.y = obj.pos !== undefined && Number.isInteger(obj.pos.y) ? obj.pos.y : 0;
      if (obj.id) container.name = obj.id;
      container.width = obj.pos !== undefined && Number.isInteger(obj.pos.w) ? obj.pos.w : this.width - container.x;
      container.height = obj.pos != undefined && Number.isInteger(obj.pos.h) ? obj.pos.h : this.height - container.y;

      if (obj.color) {
        let shape = new createjs.Shape();
        shape.name = 'shape-bgr-color';
        shape.width = container.width;
        shape.height = container.height;
        if (obj.border && obj.border != 'transparent') {
          shape.graphics.ss(obj.borderSize ? obj.borderSize : 1).s(obj.border);
          container.width += obj.borderSize;
          container.height += obj.borderSize;
        }
        shape.graphics.f(obj.color).dr(0, 0, shape.width, shape.height).ef();
        if (obj.id) shape.id = obj.id;

        container.addChild(shape);
      }
      if (obj.src && obj.src.length > 0) {
        let queue = new preload.LoadQueue();
        var self = this;

        queue.on('fileload', function (e) {
          let bmp = new createjs.Bitmap(e.result.src);
          if (e.item.id) bmp.id = e.item.id;
          if (e.item.pos !== undefined) {
            if (Number.isInteger(e.item.pos.w)) {
              bmp.scaleX = e.item.pos.w / e.result.width;
              if (!Number.isInteger(e.item.pos.h)) bmp.scaleY = bmp.scaleX;
            }
            if (Number.isInteger(e.item.pos.h)) {
              bmp.scaleY = e.item.pos.h / e.result.height;
              if (!Number.isInteger(e.item.pos.w)) bmp.scaleX = bmp.scaleY;
            }
            if (Number.isInteger(e.item.pos.x)) bmp.x = e.item.pos.x;
            if (Number.isInteger(e.item.pos.y)) bmp.y = e.item.pos.y;
          }
          let bgr = e.item.cont.getChildByName('shape-bgr-color');
          if (bgr !== null) {
            e.item.cont.addChildAt(bmp, e.item.cont.getChildIndex(bgr) + 1);
          } else e.item.cont.addChildAt(bmp, 0);
        });
        queue.on('complete', function (e) {
          self.UnCacheStage(true);
        });
        queue.loadManifest([{ cont: container, id: obj.id, src: obj.src, pos: obj.posSrc }]);
      }
      if (obj.text !== null && obj.text !== undefined) {
        let text = new createjs.Text();
        if (obj.id) text.id = obj.id;
        text.text = obj.text.val;
        text.font = obj.text.bold === true ? 'bold ' : '';
        text.font += obj.text.italic === true ? ' italic ' : '';
        text.font += obj.text.size;
        text.font += ' ';
        text.font += obj.text.font;

        text.color = obj.text.color;

        text.textBaseline = obj.text.textBaseline;
        text.textAlign = obj.text.textAlign;

        if (text.textAlign == 'center') text.x = container.width / 2;
        else if (text.textAlign == 'right' || text.textAlign == 'end') text.x = container.width;

        if (text.textBaseline == 'middle') text.y = container.height / 2;
        else if (text.textBaseline == 'bottom') text.y = container.height;

        text.x += obj.text.x;
        text.y += obj.text.y;

        text.lineHeight = obj.lineHeight || obj.text.lineHeight;
        text.lineWidth = obj.lineWidth || obj.text.lineWidth;

        container.addChild(text);
      }

      return container;
    },
    createIndx(l, pick) {
      let shuffle =
        this.initData.version.targets[l].shuffle !== undefined
          ? this.initData.version.targets[l].shuffle
          : this.initData.shuffle === true
          ? true
          : false;

      var indx = [];
      if (shuffle || pick == 1) {
        // for ( let i = 0; i < pick; i++ ) {
        //   let ix = Math.round( Math.random() * ( this.initData.sample[ l ].length - 1 ) );
        //   let flg = false;
        //   for ( let j = 0; j < indx.length; j++ )
        //     if ( indx[ j ] == ix ) flg = true;//   if ( flg ) i--;
        //   else indx[ i ] = ix;
        //   if ( pick == 1 ) break;
        // }
        indx = Array.from({ length: this.initData.sample[l].length }, (v, k) => k);
        indx = _.sampleSize(indx, pick);
        if (shuffle) {
          let baseIndx = _.shuffle(indx);
          if (indx.length === baseIndx.length && indx.every((v, i) => v === baseIndx[i])) {
            baseIndx = _.reverse(baseIndx);
          }
          indx = baseIndx;
        }
      } else {
        indx = Array.from({ length: pick }, (v, k) => k);
      }

      var copy = _.cloneDeep(indx);
      copy.sort(function (a, b) {
        return a - b;
      });

      if (this.initData.version.targets[l].sort === true) {
        indx = _.cloneDeep(copy);
      }

      var groups = [],
        self = this;
      indx.forEach(function (ind, i) {
        groups[i] = Object.assign({}, _.cloneDeep(self.initData.sample[l][ind]));
        groups[i].type = self.initData.version.targets[l].type;
      });

      this.initData.sample[l].forEach(function (item) {
        item.type = self.initData.version.targets[l].type;
      });

      return { indx: indx, groups: groups, shuffle: shuffle, all: _.cloneDeep(this.initData.sample[l]), pick: pick };
    },
    createClone(gr, inx, sampIds, ls_source, clones) {
      let sam = Object.assign({}, ls_source[gr].all[inx]);
      let indx = sampIds.indexOf(sam.id);
      let cci = 0;
      if (indx === -1) {
        if (ls_source[gr].indx.indexOf(inx) === -1) {
          ls_source[gr].groups.push(sam);
          ls_source[gr].indx.push(inx);
        }

        if (sam.clone !== undefined) {
          cci =
            sam.clone !== true && Number.isInteger(sam.clone.maxNum)
              ? sam.clone.maxNum
              : Number.isInteger(this.initData.cloneNumber)
              ? this.initData.cloneNumber
              : 100;
          if (clones[gr] === undefined) clones[gr] = [];
          clones[gr][sam.id] = [];
          this.clones[gr][sam.id] = [];
          for (let n = 0; n < cci - 1; n++) {
            let clone = _.cloneDeep(sam);
            clone.origin = sam.id;
            clone.id = sam.id + '-clone' + n;
            clone.type = 'clone';
            clones[gr][sam.id].push(clone);
          }
        }
        sampIds.push(sam.id);
      }
      return { sampIds: sampIds, ls_source: ls_source, clones: clones };
    },
    getIndexById(tab, id) {
      var ix = -1;
      tab.forEach(function (item, i) {
        if (item.id == id) {
          ix = i;
          return i;
        }
      });
      return ix;
    },
    loadSamples() {
      var self = this;
      var pick = [];
      var ls_source = [],
        ls_targets = [];
      var groups = [],
        ls_clones = [];
      this.clones = [];

      for (let i = 0; i < this.initData.sample.length; i++) {
        groups[i] = [];
        this.images[i] = [];
        this.clones[i] = [];
        let p = Number.isInteger(this.initData.version.targets[i].pick)
          ? this.initData.version.targets[i].pick
          : Number.isInteger(this.initData.pick)
          ? this.initData.pick
          : this.initData.sample[i].length;
        if (p > this.initData.sample[i].length) p = this.initData.sample[i].length;

        // -------------------------- //
        // WYBIERAMY TARGETY I ŹRÓDŁA //
        // -------------------------- //

        if (this.initData.version.targets[i].type == 'target') {
          ls_targets[i] = [];
          ls_targets[i] = this.createIndx(i, p);
        } else {
          ls_source[i] = [];
          ls_source[i] = this.createIndx(i, p);
        }

        pick.push(p);
      }

      // ---------------------------------------------------------- //
      // SPRAWDZAMY CZY ŹRÓDŁO JEST ZALEŻNE OD WYLOSOWANEGO TARGETU //
      // ---------------------------------------------------------- //

      ls_targets.forEach(function (tar) {
        tar.groups.forEach(function (tr) {
          if (tr.sourceId !== undefined) {
            ls_source[tr.sourceId.indx].groups.forEach(function (ls) {
              ls.visible = false;
            });
            ls_source[tr.sourceId.indx].groups[tr.sourceId.id].visible = true;
          }
        });
      });

      // --------------------------------------------------------------------------------------- //
      // SPRAWDZAMY CZY JEST TARGET, GDZIE ODPOWIEDŹ JEST ZALEŻNA OD WYLOSOWANEGO INNEGO TARGETU // - jebane masło maślane :P
      // --------------------------------------------------------------------------------------- //

      ls_targets.forEach(function (tar) {
        tar.groups.forEach(function (tr) {
          if (tr.correctSource !== undefined) {
            if (tr.correctSource.source.idS !== undefined && Number.isInteger(tr.correctSource.source.idS)) {
            } else
              ls_source[tr.correctSource.source.gr].groups.forEach(function (sd, ix) {
                if (sd.visible === true) {
                  let idT = self.getIndexById(
                    ls_targets[tr.correctSource.target].groups,
                    tr.correctSource.correct[ix].idT
                  );
                  if (sd.correct === undefined) {
                    sd.correct = [];
                    sd.correct.push(ls_targets[tr.correctSource.target].groups[idT].id);
                    ls_source[tr.correctSource.source.gr].all[ix].correct = sd.correct;
                  }
                  if (ls_targets[tr.correctSource.target].groups[idT].correct === undefined) {
                    ls_targets[tr.correctSource.target].groups[idT].correct = [];
                    ls_targets[tr.correctSource.target].groups[idT].correct.push(sd.id);
                  } else {
                    var flg = false;
                    for (let k = 0; k < ls_targets[tr.correctSource.target].groups[idT].correct.length; k++) {
                      if (ls_targets[tr.correctSource.target].groups[idT].correct[k] === '') {
                        ls_targets[tr.correctSource.target].groups[idT].correct[k] = sd.id;
                        flg = true;
                        break;
                      }
                    }

                    if (!flg) ls_targets[tr.correctSource.target].groups[idT].correct.push(sd.id);
                  }
                  ls_targets[tr.correctSource.target].all[idT].correct =
                    ls_targets[tr.correctSource.target].groups[idT].correct;
                }
              });
          }
        });
      });

      ls_targets.forEach(function (tar, v) {
        tar.indx.forEach(function (ind) {
          groups[v].push(tar.all[ind]);
        });
      });

      // -------------------------------------------------- //
      // SZUKAMY ŹRÓDEŁ NIEZBĘDNYCH DO ROZWIĄZANIA TARGETÓW //
      // -------------------------------------------------- //

      var sors = [],
        sampIds = [];
      ls_targets.forEach(function (tar, v) {
        tar.indx.forEach(function (ind, i) {
          if (tar.groups[i].correct !== undefined) {
            for (let k = 0; k < tar.groups[i].correct.length; k++) {
              ls_source.forEach(function (sour, j) {
                if (sors[j] == undefined) sors[j] = [];
                sour.all.forEach(function (item, l) {
                  if (item.id == tar.groups[i].correct[k]) {
                    self.createClone(j, l, sampIds, ls_source, ls_clones);
                    sors[j][l] = item;
                  }
                });
              });
            }
          }
        });
      });

      ls_source.forEach(function (sour, j) {
        var len = sour.groups.length;
        if (len > sour.pick) {
          sour.all.forEach(function (item, l) {
            if (sors[j][l] === undefined && len > sour.pick) {
              let iX = sour.indx.indexOf(l);
              if (iX !== -1) {
                sour.groups[iX] = undefined;
                sour.indx[iX] = undefined;
                len--;
              }
            }
          });
        }
      });

      // CZYŚCIMY Z UNDEFINED

      ls_source.forEach(function (sour, j) {
        var i = 0;
        do {
          if (sour.groups[i] === undefined) {
            sour.groups.splice(i, 1);
            sour.indx.splice(i, 1);
            i = 0;
          } else i++;
        } while (i < sour.groups.length);
      });

      // --------------------------------------------------- //
      // SPRAWDZIĆ ŹRÓDŁA CZY NIE MA USTALONYCH PICK I CELÓW //
      // --------------------------------------------------- //

      ls_source.forEach(function (sour, j) {
        sour.groups.forEach(function (srGr, k) {
          if (srGr !== undefined) {
            if (srGr.correct !== undefined && srGr.correct.length > 0) {
              ls_targets.forEach(function (tar) {
                tar.groups.forEach(function (tarGr, k) {
                  if (srGr.correct.indexOf(tarGr.id) !== -1) {
                    if (tarGr.correct === undefined) {
                      tarGr.correct = [];
                      tar.all[tar.indx[k]].correct = [];
                    }
                    if (tarGr.correct.indexOf(srGr.id) === -1) {
                      tarGr.correct.push(srGr.id);
                      tar.all[tar.indx[k]].correct.push(srGr.id);
                    }
                  }
                });
              });
            }
          }
        });
      });

      // -----------------//
      // TWORZENIE KLONÓW //
      // -----------------//

      sampIds.splice(0, sampIds.length - 1);

      ls_source.forEach(function (sour, j) {
        sour.groups.forEach(function (srGr, k) {
          if (srGr !== undefined) {
            self.createClone(j, sour.indx[k], sampIds, ls_source, ls_clones);
          }
        });
      });

      // ----------------------------- //
      // POŁĄCZENIE KLONÓW ZE ŹRÓDŁAMI //
      // ----------------------------- //

      ls_source.forEach(function (sour, j) {
        if (sour !== undefined) {
          sour.indx.forEach(function (ind, k) {
            if (ind !== undefined) {
              sour.all[ind].visible = sour.groups[k].visible;
              groups[j].push(sour.all[ind]);
            }
          });
          if (ls_clones[j] !== undefined)
            Object.keys(ls_clones[j]).forEach(function (key) {
              groups[j] = groups[j].concat(ls_clones[j][key]);
            });
        }
      });

      if (this.initData.version.concatSource === true && ls_source.length > 2) {
        var nx = -1;
        ls_source.forEach(function (sour, j) {
          if (sour !== undefined) {
            if (nx === -1) nx = j;
            else {
              groups[nx] = groups[nx].concat(groups[j]);
              groups[j] = undefined;
            }
          }
        });
        if (ls_source[nx].shuffle) groups[nx] = this.shuffle(this.shuffle(groups[nx]));
      }

      var manifest = [];
      console.log(groups);
      for (var i = 0; i < groups.length; i++) {
        if (groups[i] !== undefined) {
          var dist = Number.isInteger(self.initData.version.targets[i].dist)
            ? self.initData.version.targets[i].dist
            : self.initData.version.dist;
          var bl = 1;

          if (
            !Number.isInteger(self.initData.version.targets[i].pos.w) &&
            !Number.isInteger(self.initData.version.width) &&
            ((Number.isInteger(self.initData.version.targets[i].breakLine) &&
              self.initData.version.targets[i].breakLine !== 0) ||
              (Number.isInteger(self.initData.version.breakLine) && self.initData.version.breakLine !== 0))
          ) {
            bl = Number.isInteger(self.initData.version.targets[i].breakLine)
              ? self.initData.version.targets[i].breakLine
              : Number.isInteger(self.initData.version.breakLine)
              ? self.initData.version.breakLine
              : groups[i].length;
          }

          if (
            self.initData.targetBgr !== undefined ||
            self.initData.version.targetBgr !== undefined ||
            self.initData.version.targets[i].targetBgr !== undefined
          ) {
            let w = Number.isInteger(self.initData.version.targets[i].pos.w)
              ? self.initData.version.targets[i].pos.w
              : Number.isInteger(self.initData.version.width)
              ? self.initData.version.width
              : // wprowadzić poprawkę, gdy istnieje obiekt "sampleBgr", a nie istnieje "pos" - wywala błąd
              self.initData.version.isVer == true &&
                self.initData.version.targets[i].sampleBgr !== undefined &&
                Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.w)
              ? self.initData.version.targets[i].sampleBgr.pos.w * bl
              : self.initData.version.isHor == true &&
                self.initData.version.targets[i].sampleBgr !== undefined &&
                Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.w)
              ? self.initData.version.targets[i].sampleBgr.pos.w * Math.floor(pick[i] / bl) +
                dist * Math.floor((pick[i] - 1) / bl)
              : self.initData.version.isVer == true && Number.isInteger(self.initData.sampleBgr.pos.w)
              ? self.initData.sampleBgr.pos.w * bl
              : self.initData.version.isHor == true && Number.isInteger(self.initData.sampleBgr.pos.w)
              ? self.initData.sampleBgr.pos.w * Math.floor(pick[i] / bl) + dist * Math.floor((pick[i] - 1) / bl)
              : 0;
            if (!Number.isInteger(self.initData.version.targets[i].pos.w)) {
              w +=
                (self.initData.version.isVer &&
                self.initData.version.targets[i].sampleBgr &&
                self.initData.version.targets[i].sampleBgr.pos &&
                Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.x)
                  ? self.initData.version.targets[i].sampleBgr.pos.x +
                    (Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : dist) *
                      (bl - 1)
                  : self.initData.version.isHor &&
                    self.initData.version.targets[i].sampleBgr &&
                    self.initData.version.targets[i].sampleBgr.pos &&
                    Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.x)
                  ? self.initData.version.targets[i].sampleBgr.pos.x
                  : self.initData.version.isVer &&
                    self.initData.sampleBgr &&
                    self.initData.sampleBgr.pos &&
                    Number.isInteger(self.initData.sampleBgr.pos.x)
                  ? self.initData.sampleBgr.pos.x +
                    (Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : dist) *
                      (bl - 1)
                  : self.initData.version.isHor &&
                    self.initData.sampleBgr &&
                    self.initData.sampleBgr.pos &&
                    Number.isInteger(self.initData.sampleBgr.pos.x)
                  ? self.initData.sampleBgr.pos.x
                  : (Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : dist) *
                    (bl - 1)) * 2;
            }

            let h = Number.isInteger(self.initData.version.targets[i].pos.h)
              ? self.initData.version.targets[i].pos.h
              : Number.isInteger(self.initData.version.height)
              ? self.initData.version.height
              : self.initData.version.isVer == true &&
                self.initData.version.targets[i].sampleBgr !== undefined &&
                Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.h)
              ? self.initData.version.targets[i].sampleBgr.pos.h * Math.floor(pick[i] / bl) +
                dist * Math.floor((pick[i] - 1) / bl)
              : self.initData.version.isHor == true &&
                self.initData.version.targets[i].sampleBgr !== undefined &&
                Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.h)
              ? self.initData.version.targets[i].sampleBgr.pos.h * bl
              : self.initData.version.isVer == true && Number.isInteger(self.initData.sampleBgr.pos.h)
              ? self.initData.sampleBgr.pos.h * Math.floor(pick[i] / bl) + dist * Math.floor((pick[i] - 1) / bl)
              : self.initData.version.isHor == true && Number.isInteger(self.initData.sampleBgr.pos.h)
              ? self.initData.sampleBgr.pos.h * bl
              : 0;
            if (!Number.isInteger(self.initData.version.targets[i].pos.h)) {
              h +=
                (self.initData.version.isVer &&
                self.initData.version.targets[i].sampleBgr &&
                self.initData.version.targets[i].sampleBgr.pos &&
                Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.y)
                  ? self.initData.version.targets[i].sampleBgr.pos.y
                  : self.initData.version.isHor &&
                    self.initData.version.targets[i].sampleBgr &&
                    self.initData.version.targets[i].sampleBgr.pos &&
                    Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.y)
                  ? self.initData.version.targets[i].sampleBgr.pos.y +
                    (Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : dist) *
                      (bl - 1)
                  : self.initData.version.isVer &&
                    self.initData.sampleBgr &&
                    self.initData.sampleBgr.pos &&
                    Number.isInteger(self.initData.sampleBgr.pos.y)
                  ? self.initData.sampleBgr.pos.y
                  : self.initData.version.isHor &&
                    self.initData.sampleBgr &&
                    self.initData.sampleBgr.pos &&
                    Number.isInteger(self.initData.sampleBgr.pos.y)
                  ? self.initData.sampleBgr.pos.y +
                    (Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : dist) *
                      (bl - 1)
                  : (Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : Number.isInteger(self.initData.version.targets[i].distBL)
                      ? self.initData.version.targets[i].distBL
                      : dist) *
                    (bl - 1)) * 2;
            }

            let textBgr = {};
            textBgr.bold =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.bold !== undefined
                ? self.initData.version.targets[i].targetBgr.text.bold
                : self.initData.version.targets[i].sampleTxt &&
                  self.initData.version.targets[i].sampleTxt.bold !== undefined
                ? self.initData.version.targets[i].sampleTxt.bold
                : self.initData.targetBgr &&
                  self.initData.targetBgr.text &&
                  self.initData.targetBgr.text.bold !== undefined
                ? self.initData.targetBgr.text.bold
                : self.initData.sampleTxt && self.initData.sampleTxt.bold !== undefined
                ? self.initData.sampleTxt.bold
                : false;

            textBgr.italic =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.italic !== undefined
                ? self.initData.version.targets[i].targetBgr.text.italic
                : self.initData.version.targets[i].sampleTxt &&
                  self.initData.version.targets[i].sampleTxt.italic !== undefined
                ? self.initData.version.targets[i].sampleTxt.italic
                : self.initData.targetBgr &&
                  self.initData.targetBgr.text &&
                  self.initData.targetBgr.text.italic !== undefined
                ? self.initData.targetBgr.text.italic
                : self.initData.sampleTxt && self.initData.sampleTxt.italic !== undefined
                ? self.initData.sampleTxt.italic
                : false;

            textBgr.size =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.size
                ? self.initData.version.targets[i].targetBgr.text.size
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.size
                ? self.initData.version.targets[i].sampleTxt.size
                : self.initData.targetBgr && self.initData.targetBgr.text && self.initData.targetBgr.text.size
                ? self.initData.targetBgr.text.size
                : self.initData.sampleTxt && self.initData.sampleTxt.size
                ? self.initData.sampleTxt.size
                : '20px';

            textBgr.font =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.font
                ? self.initData.version.targets[i].targetBgr.text.font
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.font
                ? self.initData.version.targets[i].sampleTxt.font
                : self.initData.targetBgr && self.initData.targetBgr.text && self.initData.targetBgr.text.font
                ? self.initData.targetBgr.text.font
                : self.initData.sampleTxt && self.initData.sampleTxt.font
                ? self.initData.sampleTxt.font
                : 'Calibri';

            textBgr.color =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.color
                ? self.initData.version.targets[i].targetBgr.text.color
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.color
                ? self.initData.version.targets[i].sampleTxt.color
                : self.initData.targetBgr && self.initData.targetBgr.text && self.initData.targetBgr.text.color
                ? self.initData.targetBgr.text.color
                : self.initData.sampleTxt && self.initData.sampleTxt.color
                ? self.initData.sampleTxt.color
                : 'black';

            textBgr.textBaseline =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.textBaseline
                ? self.initData.version.targets[i].targetBgr.text.textBaseline
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.textBaseline
                ? self.initData.version.targets[i].sampleTxt.textBaseline
                : self.initData.targetBgr && self.initData.targetBgr.text && self.initData.targetBgr.text.textBaseline
                ? self.initData.targetBgr.text.textBaseline
                : self.initData.sampleTxt && self.initData.sampleTxt.textBaseline
                ? self.initData.sampleTxt.textBaseline
                : 'top';

            textBgr.textAlign =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.textAlign
                ? self.initData.version.targets[i].targetBgr.text.textAlign
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.textAlign
                ? self.initData.version.targets[i].sampleTxt.textAlign
                : self.initData.targetBgr && self.initData.targetBgr.text && self.initData.targetBgr.text.textAlign
                ? self.initData.targetBgr.text.textAlign
                : self.initData.sampleTxt && self.initData.sampleTxt.textAlign
                ? self.initData.sampleTxt.textAlign
                : 'left';

            textBgr.lineHeight =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.lineHeight
                ? self.initData.version.targets[i].targetBgr.text.lineHeight
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.lineHeight
                ? self.initData.version.targets[i].sampleTxt.lineHeight
                : self.initData.targetBgr && self.initData.targetBgr.text && self.initData.targetBgr.text.lineHeight
                ? self.initData.targetBgr.text.lineHeight
                : self.initData.sampleTxt && self.initData.sampleTxt.lineHeight
                ? self.initData.sampleTxt.lineHeight
                : 0;

            textBgr.lineWidth =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.lineWidth
                ? self.initData.version.targets[i].targetBgr.text.lineWidth
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.lineWidth
                ? self.initData.version.targets[i].sampleTxt.lineWidth
                : self.initData.targetBgr && self.initData.targetBgr.text && self.initData.targetBgr.text.lineWidth
                ? self.initData.targetBgr.text.lineWidth
                : self.initData.sampleTxt && self.initData.sampleTxt.lineWidth
                ? self.initData.sampleTxt.lineWidth
                : null;

            textBgr.val =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.text &&
              self.initData.version.targets[i].targetBgr.text.val
                ? self.initData.version.targets[i].targetBgr.text.val
                : self.initData.targetBgr && self.initData.targetBgr.text && self.initData.targetBgr.text.val
                ? self.initData.targetBgr.text.val
                : undefined;

            textBgr.x =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.posElem &&
              Number.isInteger(self.initData.version.targets[i].targetBgr.posElem.x)
                ? self.initData.version.targets[i].targetBgr.posElem.x
                : self.initData.targetBgr &&
                  self.initData.targetBgr.posElem &&
                  Number.isInteger(self.initData.targetBgr.posElem.x)
                ? self.initData.targetBgr.posElem.x
                : 0;
            textBgr.y =
              self.initData.version.targets[i].targetBgr &&
              self.initData.version.targets[i].targetBgr.posElem &&
              Number.isInteger(self.initData.version.targets[i].targetBgr.posElem.y)
                ? self.initData.version.targets[i].sampleBgr.posElem.y
                : self.initData.targetBgr &&
                  self.initData.targetBgr.posElem &&
                  Number.isInteger(self.initData.targetBgr.posElem.y)
                ? self.initData.targetBgr.posElem.y
                : 0;

            var cont = self.createContainer({
              pos: {
                x:
                  self.initData.version.targets[i].pos && Number.isInteger(self.initData.version.targets[i].pos.x)
                    ? self.initData.version.targets[i].pos.x
                    : self.initData.targetBgr.pos && Number.isInteger(self.initData.targetBgr.pos.x)
                    ? self.initData.targetBgr.pos.x
                    : 0,
                y:
                  self.initData.version.targets[i].pos && Number.isInteger(self.initData.version.targets[i].pos.y)
                    ? self.initData.version.targets[i].pos.y
                    : self.initData.targetBgr.pos && Number.isInteger(self.initData.targetBgr.pos.y)
                    ? self.initData.targetBgr.pos.y
                    : 0,
                w: w,
                h: h,
              },
              color:
                self.initData.version.targets[i].targetBgr &&
                self.initData.version.targets[i].targetBgr.color !== undefined
                  ? self.initData.version.targets[i].targetBgr.color
                  : self.initData.version.targetBgr && self.initData.version.targetBgr.color !== undefined
                  ? self.initData.version.targetBgr.color
                  : self.initData.targetBgr && self.initData.targetBgr.color !== undefined
                  ? self.initData.targetBgr.color
                  : 'transparent',
              border:
                self.initData.version.targets[i].targetBgr &&
                self.initData.version.targets[i].targetBgr.border !== undefined
                  ? self.initData.version.targets[i].targetBgr.border
                  : self.initData.version.targetBgr && self.initData.version.targetBgr.border !== undefined
                  ? self.initData.version.targetBgr.border
                  : self.initData.targetBgr && self.initData.targetBgr.border !== undefined
                  ? self.initData.targetBgr.border
                  : 'transparent',
              borderSize:
                self.initData.version.targets[i].targetBgr &&
                Number.isInteger(self.initData.version.targets[i].targetBgr.borderSize)
                  ? self.initData.version.targets[i].targetBgr.borderSize
                  : self.initData.version.targetBgr && Number.isInteger(self.initData.version.targetBgr.borderSize)
                  ? self.initData.version.targetBgr.borderSize
                  : self.initData.targetBgr && Number.isInteger(self.initData.targetBgr.borderSize)
                  ? self.initData.targetBgr.borderSize
                  : 1,
              src:
                self.initData.version.targets[i].targetBgr &&
                self.initData.version.targets[i].targetBgr.src !== undefined
                  ? self.initData.version.targets[i].targetBgr.src
                  : self.initData.version.targetBgr && self.initData.version.targetBgr.src !== undefined
                  ? self.initData.version.targetBgr.src
                  : self.initData.targetBgr && self.initData.targetBgr.src !== undefined
                  ? self.initData.targetBgr.src
                  : null,
              posSrc:
                self.initData.version.targets[i].targetBgr &&
                self.initData.version.targets[i].targetBgr.posSrc !== undefined
                  ? self.initData.version.targets[i].targetBgr.posSrc
                  : self.initData.version.targetBgr && self.initData.version.targetBgr.posSrc !== undefined
                  ? self.initData.version.targetBgr.posSrc
                  : self.initData.targetBgr && self.initData.targetBgr.posSrc !== undefined
                  ? self.initData.targetBgr.posSrc
                  : undefined,
              id: self.initData.version.targets[i].id,
              text: textBgr.val !== undefined ? textBgr : undefined,
            });
            cont.x -= self.offset.x;
            cont.y -= self.offset.y;
            cont.type = self.initData.version.targets[i].type;
            self.stage.addChild(cont);
          }

          var cX = 0,
            cY = 0,
            cols = Math.ceil(groups[i].length / bl);

          for (var j = 0; j < groups[i].length; j++) {
            var item = groups[i][j];
            item.gr = i;
            var distBl = Number.isInteger(self.initData.version.targets[i].distBL)
              ? self.initData.version.targets[i].distBL
              : Number.isInteger(self.initData.distBL)
              ? self.initData.distBL
              : dist;

            // określenie wielkości KONTENERA
            let dim = {
              w:
                item.pos && Number.isInteger(item.pos.w)
                  ? item.pos.w
                  : self.initData.version.targets[i].sampleBgr &&
                    self.initData.version.targets[i].sampleBgr.pos &&
                    Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.w)
                  ? self.initData.version.targets[i].sampleBgr.pos.w
                  : self.initData.sampleBgr &&
                    self.initData.sampleBgr.pos &&
                    Number.isInteger(self.initData.sampleBgr.pos.w)
                  ? self.initData.sampleBgr.pos.w
                  : 100,
              h:
                item.pos && Number.isInteger(item.pos.h)
                  ? item.pos.h
                  : self.initData.version.targets[i].sampleBgr &&
                    self.initData.version.targets[i].sampleBgr.pos &&
                    Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.h)
                  ? self.initData.version.targets[i].sampleBgr.pos.h
                  : self.initData.sampleBgr &&
                    self.initData.sampleBgr.pos &&
                    Number.isInteger(self.initData.sampleBgr.pos.h)
                  ? self.initData.sampleBgr.pos.h
                  : 100,
            };

            if (self.initData.version.isHor && j > 0 && j % cols == 0) cY++;
            if (self.initData.version.isHor) {
              cX = j % cols;
            }
            if (self.initData.version.isVer && j > 0 && j % cols == 0) cX++;
            if (self.initData.version.isVer) cY = j % cols;

            let x =
              item.pos && Number.isInteger(item.pos.x)
                ? item.pos.x
                : self.initData.version.isVer &&
                  self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.pos &&
                  Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.x)
                ? self.initData.version.targets[i].sampleBgr.pos.x + (dim.w + distBl) * cX
                : self.initData.version.isHor &&
                  self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.pos &&
                  Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.x)
                ? self.initData.version.targets[i].sampleBgr.pos.x + (dim.w + dist) * cX
                : self.initData.version.isVer &&
                  self.initData.sampleBgr &&
                  self.initData.sampleBgr.pos &&
                  Number.isInteger(self.initData.sampleBgr.pos.x)
                ? self.initData.sampleBgr.pos.x + (dim.w + distBl) * cX
                : self.initData.version.isHor &&
                  self.initData.sampleBgr &&
                  self.initData.sampleBgr.pos &&
                  Number.isInteger(self.initData.sampleBgr.pos.x)
                ? self.initData.sampleBgr.pos.x + (dim.w + dist) * cX
                : self.initData.version.isHor
                ? (self.initData.sampleBgr.pos.x + dim.w + dist) * cX
                : 0;

            let y =
              item.pos && Number.isInteger(item.pos.y)
                ? item.pos.y
                : self.initData.version.isVer &&
                  self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.pos &&
                  Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.y)
                ? self.initData.version.targets[i].sampleBgr.pos.y + (dim.h + dist) * cY
                : self.initData.version.isHor &&
                  self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.pos &&
                  Number.isInteger(self.initData.version.targets[i].sampleBgr.pos.y)
                ? self.initData.version.targets[i].sampleBgr.pos.y + (dim.h + distBl) * cY
                : self.initData.version.isVer &&
                  self.initData.sampleBgr &&
                  self.initData.sampleBgr.pos &&
                  Number.isInteger(self.initData.sampleBgr.pos.y)
                ? self.initData.sampleBgr.pos.y + (dim.h + dist) * cY
                : self.initData.version.isHor &&
                  self.initData.sampleBgr &&
                  self.initData.sampleBgr.pos &&
                  Number.isInteger(self.initData.sampleBgr.pos.y)
                ? self.initData.sampleBgr.pos.y + (dim.h + distBl) * cY
                : self.initData.version.isVer
                ? (self.initData.sampleBgr.pos.y + dim.h + dist) * cY
                : 0;

            if (item.type == 'clone') {
              var origin = self.stage.getChildByName(item.origin);

              if (origin === null) {
                if (self.images[i].length > 0) {
                  self.images[i].forEach(function (org) {
                    if (org.id == item.origin) origin = org;
                  });
                }
                if (origin === null) {
                  manifest.forEach(function (org) {
                    if (org.id == item.origin) origin = org.cont;
                  });
                }
              }
              if (origin !== null) {
                x = origin.x - cont.x;
                y = origin.y - cont.y;
              }
            }

            var contrSets = {
              color:
                item.sampleBgr && item.sampleBgr.color !== undefined
                  ? item.sampleBgr.color
                  : self.initData.version.targets[i].sampleBgr &&
                    self.initData.version.targets[i].sampleBgr.color !== undefined
                  ? Array.isArray(self.initData.version.targets[i].sampleBgr.color)
                    ? self.initData.version.targets[i].sampleBgr.color[j]
                    : self.initData.version.targets[i].sampleBgr.color
                  : self.initData.sampleBgr && self.initData.sampleBgr.color !== undefined
                  ? self.initData.sampleBgr.color
                  : 'transparent',
              border:
                item.sampleBgr && item.sampleBgr.border !== undefined
                  ? item.sampleBgr.border
                  : self.initData.version.targets[i].sampleBgr &&
                    self.initData.version.targets[i].sampleBgr.border !== undefined
                  ? self.initData.version.targets[i].sampleBgr.border
                  : self.initData.sampleBgr && self.initData.sampleBgr.border !== undefined
                  ? self.initData.sampleBgr.border
                  : 'transparent',
              borderSize:
                item.sampleBgr && Number.isInteger(item.sampleBgr.borderSize)
                  ? item.sampleBgr.borderSize
                  : self.initData.version.targets[i].sampleBgr &&
                    Number.isInteger(self.initData.version.targets[i].sampleBgr.borderSize)
                  ? self.initData.version.targets[i].sampleBgr.borderSize
                  : self.initData.sampleBgr && Number.isInteger(self.initData.sampleBgr.borderSize)
                  ? self.initData.sampleBgr.borderSize
                  : 1,
              src:
                item.sampleBgr && item.sampleBgr.src !== undefined
                  ? item.sampleBgr.src
                  : self.initData.version.targets[i].sampleBgr &&
                    self.initData.version.targets[i].sampleBgr.src !== undefined
                  ? Array.isArray(self.initData.version.targets[i].sampleBgr.src)
                    ? self.initData.version.targets[i].sampleBgr.src[j]
                    : self.initData.version.targets[i].sampleBgr.src
                  : self.initData.sampleBgr && self.initData.sampleBgr.src !== undefined
                  ? self.initData.sampleBgr.src
                  : null,
              posSrc:
                item.sampleBgr && item.sampleBgr.posSrc !== undefined
                  ? item.sampleBgr.posSrc
                  : self.initData.version.targets[i].sampleBgr &&
                    self.initData.version.targets[i].sampleBgr.posSrc !== undefined
                  ? Array.isArray(self.initData.version.targets[i].sampleBgr.posSrc)
                    ? self.initData.version.targets[i].sampleBgr.posSrc[j]
                    : self.initData.version.targets[i].sampleBgr.posSrc
                  : self.initData.sampleBgr && self.initData.sampleBgr.posSrc !== undefined
                  ? self.initData.sampleBgr.posSrc
                  : undefined,
            };

            let textBgr = {};
            textBgr.bold =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.bold !== undefined
                ? item.sampleBgr.text.bold
                : item.sampleTxt && item.sampleTxt.bold !== undefined
                ? item.sampleTxt.bold
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.bold !== undefined
                ? self.initData.version.targets[i].sampleBgr.text.bold
                : self.initData.version.targets[i].sampleTxt &&
                  self.initData.version.targets[i].sampleTxt.bold !== undefined
                ? self.initData.version.targets[i].sampleTxt.bold
                : self.initData.sampleBgr &&
                  self.initData.sampleBgr.text &&
                  self.initData.sampleBgr.text.bold !== undefined
                ? self.initData.sampleBgr.text.bold
                : self.initData.sampleTxt && self.initData.sampleTxt.bold !== undefined
                ? self.initData.sampleTxt.bold
                : false;

            textBgr.italic =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.italic !== undefined
                ? item.sampleBgr.text.italic
                : item.sampleTxt && item.sampleTxt.italic !== undefined
                ? item.sampleTxt.italic
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.italic !== undefined
                ? self.initData.version.targets[i].sampleBgr.text.italic
                : self.initData.version.targets[i].sampleTxt &&
                  self.initData.version.targets[i].sampleTxt.italic !== undefined
                ? self.initData.version.targets[i].sampleTxt.italic
                : self.initData.sampleBgr &&
                  self.initData.sampleBgr.text &&
                  self.initData.sampleBgr.text.italic !== undefined
                ? self.initData.sampleBgr.text.italic
                : self.initData.sampleTxt && self.initData.sampleTxt.italic !== undefined
                ? self.initData.sampleTxt.italic
                : false;

            textBgr.size =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.size
                ? item.sampleBgr.text.size
                : item.sampleTxt && item.sampleTxt.size
                ? item.sampleTxt.size
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.size
                ? self.initData.version.targets[i].sampleBgr.text.size
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.size
                ? self.initData.version.targets[i].sampleTxt.size
                : self.initData.sampleBgr && self.initData.sampleBgr.text && self.initData.sampleBgr.text.size
                ? self.initData.sampleBgr.text.size
                : self.initData.sampleTxt && self.initData.sampleTxt.size
                ? self.initData.sampleTxt.size
                : '20px';

            textBgr.font =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.font
                ? item.sampleBgr.text.font
                : item.sampleTxt && item.sampleTxt.font
                ? item.sampleTxt.font
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.font
                ? self.initData.version.targets[i].sampleBgr.text.font
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.font
                ? self.initData.version.targets[i].sampleTxt.font
                : self.initData.sampleBgr && self.initData.sampleBgr.text && self.initData.sampleBgr.text.font
                ? self.initData.sampleBgr.text.font
                : self.initData.sampleTxt && self.initData.sampleTxt.font
                ? self.initData.sampleTxt.font
                : 'Calibri';

            textBgr.color =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.color
                ? item.sampleBgr.text.color
                : item.sampleTxt && item.sampleTxt.color
                ? item.sampleTxt.color
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.color
                ? self.initData.version.targets[i].sampleBgr.text.color
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.color
                ? self.initData.version.targets[i].sampleTxt.color
                : self.initData.sampleBgr && self.initData.sampleBgr.text && self.initData.sampleBgr.text.color
                ? self.initData.sampleBgr.text.color
                : self.initData.sampleTxt && self.initData.sampleTxt.color
                ? self.initData.sampleTxt.color
                : 'black';

            textBgr.textBaseline =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.textBaseline
                ? item.sampleBgr.text.textBaseline
                : item.sampleTxt && item.sampleTxt.textBaseline
                ? item.sampleTxt.textBaseline
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.textBaseline
                ? self.initData.version.targets[i].sampleBgr.text.textBaseline
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.textBaseline
                ? self.initData.version.targets[i].sampleTxt.textBaseline
                : self.initData.sampleBgr && self.initData.sampleBgr.text && self.initData.sampleBgr.text.textBaseline
                ? self.initData.sampleBgr.text.textBaseline
                : self.initData.sampleTxt && self.initData.sampleTxt.textBaseline
                ? self.initData.sampleTxt.textBaseline
                : 'top';

            textBgr.textAlign =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.textAlign
                ? item.sampleBgr.text.textAlign
                : item.sampleTxt && item.sampleTxt.textAlign
                ? item.sampleTxt.textAlign
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.textAlign
                ? self.initData.version.targets[i].sampleBgr.text.textAlign
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.textAlign
                ? self.initData.version.targets[i].sampleTxt.textAlign
                : self.initData.sampleBgr && self.initData.sampleBgr.text && self.initData.sampleBgr.text.textAlign
                ? self.initData.sampleBgr.text.textAlign
                : self.initData.sampleTxt && self.initData.sampleTxt.textAlign
                ? self.initData.sampleTxt.textAlign
                : 'left';

            textBgr.lineHeight =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.lineHeight
                ? item.sampleBgr.text.lineHeight
                : item.sampleTxt && item.sampleTxt.lineHeight
                ? item.sampleTxt.lineHeight
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.lineHeight
                ? self.initData.version.targets[i].sampleBgr.text.lineHeight
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.lineHeight
                ? self.initData.version.targets[i].sampleTxt.lineHeight
                : self.initData.sampleBgr && self.initData.sampleBgr.text && self.initData.sampleBgr.text.lineHeight
                ? self.initData.sampleBgr.text.lineHeight
                : self.initData.sampleTxt && self.initData.sampleTxt.lineHeight
                ? self.initData.sampleTxt.lineHeight
                : 0;

            textBgr.lineWidth =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.lineWidth
                ? item.sampleBgr.text.lineWidth
                : item.sampleTxt && item.sampleTxt.lineWidth
                ? item.sampleTxt.lineWidth
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.lineWidth
                ? self.initData.version.targets[i].sampleBgr.text.lineWidth
                : self.initData.version.targets[i].sampleTxt && self.initData.version.targets[i].sampleTxt.lineWidth
                ? self.initData.version.targets[i].sampleTxt.lineWidth
                : self.initData.sampleBgr && self.initData.sampleBgr.text && self.initData.sampleBgr.text.lineWidth
                ? self.initData.sampleBgr.text.lineWidth
                : self.initData.sampleTxt && self.initData.sampleTxt.lineWidth
                ? self.initData.sampleTxt.lineWidth
                : null;

            textBgr.val =
              item.sampleBgr && item.sampleBgr.text && item.sampleBgr.text.val
                ? item.sampleBgr.text.val
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.text &&
                  self.initData.version.targets[i].sampleBgr.text.val
                ? self.initData.version.targets[i].sampleBgr.text.val
                : self.initData.sampleBgr && self.initData.sampleBgr.text && self.initData.sampleBgr.text.val
                ? self.initData.sampleBgr.text.val
                : undefined;

            textBgr.x =
              item.posElem && Number.isInteger(item.posElem.x)
                ? item.posElem.x
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.posElem &&
                  Number.isInteger(self.initData.version.targets[i].sampleBgr.posElem.x)
                ? self.initData.version.targets[i].sampleBgr.posElem.x
                : self.initData.sampleBgr &&
                  self.initData.sampleBgr.posElem &&
                  Number.isInteger(self.initData.sampleBgr.posElem.x)
                ? self.initData.sampleBgr.posElem.x
                : 0;
            textBgr.y =
              item.posElem && Number.isInteger(item.posElem.y)
                ? item.posElem.y
                : self.initData.version.targets[i].sampleBgr &&
                  self.initData.version.targets[i].sampleBgr.posElem &&
                  Number.isInteger(self.initData.version.targets[i].sampleBgr.posElem.y)
                ? self.initData.version.targets[i].sampleBgr.posElem.y
                : self.initData.sampleBgr &&
                  self.initData.sampleBgr.posElem &&
                  Number.isInteger(self.initData.sampleBgr.posElem.y)
                ? self.initData.sampleBgr.posElem.y
                : 0;

            if (
              self.initData.inLine === true &&
              self.initData.version.targets[i].type == 'source' &&
              i > self.initData.version.targets[i].target
            ) {
              x = self.images[self.initData.version.targets[i].target][j].x - cont.x;
              y = self.images[self.initData.version.targets[i].target][j].y - cont.y;
            }

            let contr = self.createContainer({
              id: item.id,
              pos: {
                x: x,
                y: y,
                w: dim.w,
                h: dim.h,
              },
              color: contrSets.color,
              border: contrSets.border,
              borderSize: contrSets.borderSize,
              src: contrSets.src,
              posSrc: contrSets.posSrc,
              text: textBgr.val !== undefined ? textBgr : undefined,
            });
            contr.id = item.id;

            if (item.visible === false) contr.visible = false;
            if (item.posFromGr !== undefined) {
              var flg = false;
              this.images[item.posFromGr.indx].forEach(function (tmp, q) {
                if (tmp.id == item.posFromGr.id && !flg) {
                  contr.x += tmp.x;
                  contr.y += tmp.y;
                  flg = true;
                }
              });
            } else {
              contr.x += cont.x;
              contr.y += cont.y;
            }
            contr.posStart = { x: contr.x, y: contr.y };
            contr.points = [];
            contr.lines = 0;
            contr.hooks = [];
            if (item.origin !== undefined) contr.origin = item.origin;
            contr.status = 0;
            contr.correct = item.correct;
            contr.hooksCount =
              item.hooksCount !== undefined && Number.isInteger(item.hooksCount) ? item.hooksCount : undefined;
            contr.block =
              item.block !== undefined
                ? item.block
                : self.initData.version.targets[i].block !== undefined
                ? self.initData.version.targets[i].block
                : false;
            contr.type = item.type === undefined ? self.initData.version.targets[i].type : item.type;
            if (contr.type === 'target') {
              self.targets[i] = [];
            }
            if (self.initData.version.targets[i].target !== undefined)
              contr.target = self.initData.version.targets[i].target;
            if (item.tip !== undefined) contr.tip = item.tip;
            if (item.corrTips !== undefined) contr.corrTips = item.corrTips;
            contr.tipStart =
              item.tipStart !== undefined
                ? item.tipStart
                : self.initData.version.targets[i].tipStart !== undefined
                ? self.initData.version.targets[i].tipStart
                : undefined;
            if (item.regs !== undefined || self.initData.version.targets[i].regs !== undefined) {
              contr.regX =
                item.regs !== undefined && Number.isInteger(item.regs.x)
                  ? item.regs.x
                  : self.initData.version.targets[i].regs !== undefined &&
                    Number.isInteger(self.initData.version.targets[i].regs.x)
                  ? self.initData.version.targets[i].regs.x
                  : contr.regX;
              contr.regY =
                item.regs !== undefined && Number.isInteger(item.regs.y)
                  ? item.regs.y
                  : self.initData.version.targets[i].regs !== undefined &&
                    Number.isInteger(self.initData.version.targets[i].regs.y)
                  ? self.initData.version.targets[i].regs.y
                  : contr.regY;
              contr.x += contr.regX;
              contr.y += contr.regY;
            }
            contr.target =
              self.initData.version.targets[i].target !== undefined
                ? self.initData.version.targets[i].target
                : undefined;
            // contr.regs = (item.regs !== undefined) item.regs : (self.initData.version.targets[i].regs !== undefined) ? self.initData.version.targets[i].regs : undefined;

            item.cont = contr;
            if (self.initData.point !== false) {
              var k = 0,
                flg = false;
              if (item.point !== undefined) flg = Array.isArray(item.point);
              else if (self.initData.version.targets[i].point !== undefined)
                flg = Array.isArray(self.initData.version.targets[i].point);
              else flg = Array.isArray(self.initData.point);
              contr.point = [];
              do {
                let rad =
                  item.point !== undefined &&
                  Array.isArray(item.point) === true &&
                  item.point[k] !== undefined &&
                  Number.isInteger(item.point[k].rad)
                    ? item.point[k].rad
                    : item.point !== undefined &&
                      Array.isArray(item.point) === false &&
                      Number.isInteger(item.point.rad)
                    ? item.point.rad
                    : self.initData.version.targets[i].point !== undefined &&
                      Array.isArray(self.initData.version.targets[i].point) === true &&
                      self.initData.version.targets[i].point[k] !== undefined &&
                      Number.isInteger(self.initData.version.targets[i].point[k].rad)
                    ? self.initData.version.targets[i].point[k].rad
                    : self.initData.version.targets[i].point !== undefined &&
                      Array.isArray(self.initData.version.targets[i].point) === false &&
                      Number.isInteger(self.initData.version.targets[i].point.rad)
                    ? self.initData.version.targets[i].point.rad
                    : self.initData.point !== undefined &&
                      Array.isArray(self.initData.point) === true &&
                      self.initData.point[k] !== undefined &&
                      Number.isInteger(self.initData.point[k].rad)
                    ? self.initData.point[k].rad
                    : self.initData.point !== undefined &&
                      Array.isArray(self.initData.point) === false &&
                      Number.isInteger(self.initData.point.rad)
                    ? self.initData.point.rad
                    : 8;

                let point = new createjs.Shape();
                //              contr.point = new createjs.Shape();
                point.graphics
                  .beginFill(
                    item.point !== undefined &&
                      Array.isArray(item.point) === true &&
                      item.point[k] !== undefined &&
                      item.point[k].color !== undefined
                      ? item.point[k].color
                      : item.point !== undefined &&
                        Array.isArray(item.point) === false &&
                        item.point.color !== undefined
                      ? item.point.color
                      : self.initData.version.targets[i].point !== undefined &&
                        Array.isArray(self.initData.version.targets[i].point) === true &&
                        self.initData.version.targets[i].point[k] !== undefined &&
                        self.initData.version.targets[i].point[k].color !== undefined
                      ? self.initData.version.targets[i].point[k].color
                      : self.initData.version.targets[i].point !== undefined &&
                        Array.isArray(self.initData.version.targets[i].point) === false &&
                        self.initData.version.targets[i].point.color !== undefined
                      ? self.initData.version.targets[i].point.color
                      : self.initData.point !== undefined &&
                        Array.isArray(self.initData.point) === true &&
                        self.initData.point[k] !== undefined &&
                        self.initData.point[k].color !== undefined
                      ? self.initData.point[k].color
                      : self.initData.point !== undefined &&
                        Array.isArray(self.initData.point) === false &&
                        self.initData.point.color !== undefined
                      ? self.initData.point.color
                      : 'rgba(0,0,0,0.3)'
                  )
                  .drawCircle(0, 0, rad);

                point.x =
                  item.point !== undefined &&
                  Array.isArray(item.point) === true &&
                  item.point[k] !== undefined &&
                  item.point[k].pos !== undefined &&
                  Number.isInteger(item.point[k].pos.x)
                    ? item.point[k].pos.x
                    : item.point !== undefined &&
                      Array.isArray(item.point) === false &&
                      item.point.pos !== undefined &&
                      Number.isInteger(item.point.pos.x)
                    ? item.point.pos.x
                    : self.initData.version.targets[i].point !== undefined &&
                      Array.isArray(self.initData.version.targets[i].point) === true &&
                      self.initData.version.targets[i].point[k] !== undefined &&
                      self.initData.version.targets[i].point[k].pos !== undefined &&
                      Number.isInteger(self.initData.version.targets[i].point[k].pos.x)
                    ? self.initData.version.targets[i].point[k].pos.x
                    : self.initData.version.targets[i].point !== undefined &&
                      Array.isArray(self.initData.version.targets[i].point) === false &&
                      self.initData.version.targets[i].point.pos !== undefined &&
                      Number.isInteger(self.initData.version.targets[i].point.pos.x)
                    ? self.initData.version.targets[i].point.pos.x
                    : self.initData.point !== undefined &&
                      Array.isArray(self.initData.point) === true &&
                      self.initData.point[k] !== undefined &&
                      self.initData.point[k].pos !== undefined &&
                      Number.isInteger(self.initData.point[k].pos.x)
                    ? self.initData.point[k].pos.x
                    : self.initData.point !== undefined &&
                      Array.isArray(self.initData.point) === false &&
                      self.initData.point.pos !== undefined &&
                      Number.isInteger(self.initData.point.pos.x)
                    ? self.initData.point.pos.x
                    : false;

                point.y =
                  item.point !== undefined &&
                  Array.isArray(item.point) === true &&
                  item.point[k] !== undefined &&
                  item.point[k].pos !== undefined &&
                  Number.isInteger(item.point[k].pos.y)
                    ? item.point[k].pos.y
                    : item.point !== undefined &&
                      Array.isArray(item.point) === false &&
                      item.point.pos !== undefined &&
                      Number.isInteger(item.point.pos.y)
                    ? item.point.pos.y
                    : self.initData.version.targets[i].point !== undefined &&
                      Array.isArray(self.initData.version.targets[i].point) === true &&
                      self.initData.version.targets[i].point[k] !== undefined &&
                      self.initData.version.targets[i].point[k].pos !== undefined &&
                      Number.isInteger(self.initData.version.targets[i].point[k].pos.y)
                    ? self.initData.version.targets[i].point[k].pos.y
                    : self.initData.version.targets[i].point !== undefined &&
                      Array.isArray(self.initData.version.targets[i].point) === false &&
                      self.initData.version.targets[i].point.pos !== undefined &&
                      Number.isInteger(self.initData.version.targets[i].point.pos.y)
                    ? self.initData.version.targets[i].point.pos.y
                    : self.initData.point !== undefined &&
                      Array.isArray(self.initData.point) === true &&
                      self.initData.point[k] !== undefined &&
                      self.initData.point[k].pos !== undefined &&
                      Number.isInteger(self.initData.point[k].pos.y)
                    ? self.initData.point[k].pos.y
                    : self.initData.point !== undefined &&
                      Array.isArray(self.initData.point) === false &&
                      self.initData.point.pos !== undefined &&
                      Number.isInteger(self.initData.point.pos.y)
                    ? self.initData.point.pos.y
                    : false;
                point.rad = rad;

                if (point.x === false || point.x === undefined || point.y === false || point.y === undefined) {
                  switch (
                    (item.point !== undefined &&
                    Array.isArray(item.point) === true &&
                    item.point[k] !== undefined &&
                    item.point[k].position !== undefined
                      ? item.point[k].position
                      : item.point !== undefined &&
                        Array.isArray(item.point) === false &&
                        item.point.position !== undefined
                      ? item.point.position
                      : self.initData.version.targets[i].point !== undefined &&
                        Array.isArray(self.initData.version.targets[i].point) === true &&
                        self.initData.version.targets[i].point[k] !== undefined &&
                        self.initData.version.targets[i].point[k].position !== undefined
                      ? self.initData.version.targets[i].point[k].position
                      : self.initData.version.targets[i].point !== undefined &&
                        Array.isArray(self.initData.version.targets[i].point) === false &&
                        self.initData.version.targets[i].point.position !== undefined
                      ? self.initData.version.targets[i].point.position
                      : self.initData.point !== undefined &&
                        Array.isArray(self.initData.point) === true &&
                        self.initData.point[k] !== undefined &&
                        self.initData.point[k].position !== undefined
                      ? self.initData.point[k].position
                      : self.initData.point !== undefined &&
                        Array.isArray(self.initData.point) === false &&
                        self.initData.point.position !== undefined
                      ? self.initData.point.position
                      : 'center'
                    ).toLowerCase()
                  ) {
                    case 'top':
                      point.x = contr.x + contr.width / 2;
                      point.y = contr.y - rad;
                      break;
                    case 'bottom':
                      point.x = contr.x + contr.width / 2;
                      point.y = contr.y + contr.height + rad;
                      break;
                    case 'left':
                      point.x = contr.x - rad;
                      point.y = contr.y + contr.height / 2;
                      break;
                    case 'right':
                      point.x = contr.x + contr.width + rad;
                      point.y = contr.y + contr.height / 2;
                      break;
                    default:
                      point.x = contr.x + contr.width / 2;
                      point.y = contr.y + contr.height / 2;
                  }
                  let offset = {
                    x:
                      item.point !== undefined &&
                      Array.isArray(item.point) === true &&
                      item.point[k] !== undefined &&
                      item.point[k].offset !== undefined &&
                      Number.isInteger(item.point[k].offset.x)
                        ? item.point[k].offset.x
                        : item.point !== undefined &&
                          Array.isArray(item.point) === false &&
                          item.point.offset !== undefined &&
                          Number.isInteger(item.point.offset.x)
                        ? item.point.offset.x
                        : self.initData.version.targets[i].point !== undefined &&
                          Array.isArray(self.initData.version.targets[i].point) === true &&
                          self.initData.version.targets[i].point[k] !== undefined &&
                          self.initData.version.targets[i].point[k].offset !== undefined &&
                          Number.isInteger(self.initData.version.targets[i].point[k].offset.x)
                        ? self.initData.version.targets[i].point[k].offset.x
                        : self.initData.version.targets[i].point !== undefined &&
                          Array.isArray(self.initData.version.targets[i].point) === false &&
                          self.initData.version.targets[i].point.offset !== undefined &&
                          Number.isInteger(self.initData.version.targets[i].point.offset.x)
                        ? self.initData.version.targets[i].point.offset.x
                        : self.initData.point !== undefined &&
                          Array.isArray(self.initData.point) === true &&
                          self.initData.point[k] !== undefined &&
                          self.initData.point[k].offset !== undefined &&
                          Number.isInteger(self.initData.point[k].offset.x)
                        ? self.initData.point[k].offset.x
                        : self.initData.point !== undefined &&
                          Array.isArray(self.initData.point) === false &&
                          self.initData.point.offset !== undefined &&
                          Number.isInteger(self.initData.point.offset.x)
                        ? self.initData.point.offset.x
                        : 0,
                    y:
                      item.point !== undefined &&
                      Array.isArray(item.point) === true &&
                      item.point[k] !== undefined &&
                      item.point[k].offset !== undefined &&
                      Number.isInteger(item.point[k].offset.y)
                        ? item.point[k].offset.y
                        : item.point !== undefined &&
                          Array.isArray(item.point) === false &&
                          item.point.offset !== undefined &&
                          Number.isInteger(item.point.offset.y)
                        ? item.point.offset.y
                        : self.initData.version.targets[i].point !== undefined &&
                          Array.isArray(self.initData.version.targets[i].point) === true &&
                          self.initData.version.targets[i].point[k] !== undefined &&
                          self.initData.version.targets[i].point[k].offset !== undefined &&
                          Number.isInteger(self.initData.version.targets[i].point[k].offset.y)
                        ? self.initData.version.targets[i].point[k].offset.y
                        : self.initData.version.targets[i].point !== undefined &&
                          Array.isArray(self.initData.version.targets[i].point) === false &&
                          self.initData.version.targets[i].point.offset !== undefined &&
                          Number.isInteger(self.initData.version.targets[i].point.offset.y)
                        ? self.initData.version.targets[i].point.offset.y
                        : self.initData.point !== undefined &&
                          Array.isArray(self.initData.point) === true &&
                          self.initData.point[k] !== undefined &&
                          self.initData.point[k].offset !== undefined &&
                          Number.isInteger(self.initData.point[k].offset.y)
                        ? self.initData.point[k].offset.y
                        : self.initData.point !== undefined &&
                          Array.isArray(self.initData.point) === false &&
                          self.initData.point.offset !== undefined &&
                          Number.isInteger(self.initData.point.offset.y)
                        ? self.initData.point.offset.y
                        : 0,
                  };
                  point.x += offset.x;
                  point.y += offset.y;
                }
                point.id = contr.id;
                point.visible =
                  item.point !== undefined &&
                  Array.isArray(item.point) === true &&
                  item.point[k] !== undefined &&
                  item.point[k].alwaysShow !== undefined
                    ? item.point[k].alwaysShow
                    : item.point !== undefined &&
                      Array.isArray(item.point) === false &&
                      item.point.alwaysShow !== undefined
                    ? item.point.alwaysShow
                    : self.initData.version.targets[i].point !== undefined &&
                      Array.isArray(self.initData.version.targets[i].point) === true &&
                      self.initData.version.targets[i].point[k] !== undefined &&
                      self.initData.version.targets[i].point[k].alwaysShow !== undefined
                    ? self.initData.version.targets[i].point[k].alwaysShow
                    : self.initData.version.targets[i].point !== undefined &&
                      Array.isArray(self.initData.version.targets[i].point) === false &&
                      self.initData.version.targets[i].point.alwaysShow !== undefined
                    ? self.initData.version.targets[i].point.alwaysShow
                    : self.initData.point !== undefined &&
                      Array.isArray(self.initData.point) === true &&
                      self.initData.point[k] !== undefined &&
                      self.initData.point[k].alwaysShow !== undefined
                    ? self.initData.point[k].alwaysShow
                    : self.initData.point !== undefined &&
                      Array.isArray(self.initData.point) === false &&
                      self.initData.point.alwaysShow !== undefined
                    ? self.initData.point.alwaysShow
                    : false;

                point.alwaysShow = point.visible;
                point.listener = {
                  md: point.on('mousedown', self.stageMouseDown),
                  pu: point.on('pressup', self.stageMouseUp),
                };
                contr.point.push(point);
                if (flg === true) {
                  k++;
                  if (item.point !== undefined && item.point[k] === undefined) flg = false;
                  else if (
                    item.point === undefined &&
                    self.initData.version.targets[i].point !== undefined &&
                    self.initData.version.targets[i].point[k] === undefined
                  )
                    flg = false;
                  else if (
                    item.point === undefined &&
                    self.initData.version.targets[i].point === undefined &&
                    self.initData.point !== undefined &&
                    self.initData.point[k] === undefined
                  )
                    flg = false;
                }
              } while (flg);
            }
            if (contr.block !== true) {
              contr.listener = {
                md: contr.on('mousedown', self.stageMouseDown),
                pu: contr.on('pressup', self.stageMouseUp),
              };
            }
            if (item.src !== undefined) {
              item.type = 'image';
              // określenie wielkości obrazka
              item.dim = {
                w:
                  item.posElem && Number.isInteger(item.posElem.w)
                    ? item.posElem.w
                    : self.initData.version.targets[i].sampleBgr &&
                      self.initData.version.targets[i].sampleBgr.posElem &&
                      Number.isInteger(self.initData.version.targets[i].sampleBgr.posElem.w)
                    ? self.initData.version.targets[i].sampleBgr.posElem.w
                    : self.initData.sampleBgr &&
                      self.initData.sampleBgr.posElem &&
                      Number.isInteger(self.initData.sampleBgr.posElem.w)
                    ? self.initData.sampleBgr.posElem.w
                    : 100,
                h:
                  item.posElem && Number.isInteger(item.posElem.h)
                    ? item.posElem.h
                    : self.initData.version.targets[i].sampleBgr &&
                      self.initData.version.targets[i].sampleBgr.posElem &&
                      Number.isInteger(self.initData.version.targets[i].sampleBgr.posElem.h)
                    ? self.initData.version.targets[i].sampleBgr.posElem.h
                    : self.initData.sampleBgr &&
                      self.initData.sampleBgr.posElem &&
                      Number.isInteger(self.initData.sampleBgr.posElem.h)
                    ? self.initData.sampleBgr.posElem.h
                    : 100,
              };

              item.cord = {
                x:
                  item.posElem && Number.isInteger(item.posElem.x)
                    ? item.posElem.x
                    : self.initData.version.targets[i].sampleBgr &&
                      self.initData.version.targets[i].sampleBgr.posElem &&
                      Number.isInteger(self.initData.version.targets[i].sampleBgr.posElem.x)
                    ? self.initData.version.targets[i].sampleBgr.posElem.x
                    : self.initData.sampleBgr &&
                      self.initData.sampleBgr.posElem &&
                      Number.isInteger(self.initData.sampleBgr.posElem.x)
                    ? self.initData.sampleBgr.posElem.x
                    : 0,
                y:
                  item.posElem && Number.isInteger(item.posElem.y)
                    ? item.posElem.y
                    : self.initData.version.targets[i].sampleBgr &&
                      self.initData.version.targets[i].sampleBgr.posElem &&
                      Number.isInteger(self.initData.version.targets[i].sampleBgr.posElem.y)
                    ? self.initData.version.targets[i].sampleBgr.posElem.y
                    : self.initData.sampleBgr &&
                      self.initData.sampleBgr.posElem &&
                      Number.isInteger(self.initData.sampleBgr.posElem.y)
                    ? self.initData.sampleBgr.posElem.y
                    : 0,
              };

              manifest.push(item);
            } else if (item.text !== undefined) {
              // var flg = Array.isArray(item.text);
              var txt = [],
                iX = 0;
              if (!Array.isArray(item.text)) txt.push(item.text);
              else txt = item.text;
              do {
                let text = new createjs.Text();
                text.id = item.id;
                text.text = txt[iX].val;
                text.font =
                  (txt[iX].bold !== undefined
                    ? txt[iX].bold
                    : self.initData.version.targets[i].sampleTxt &&
                      self.initData.version.targets[i].sampleTxt.bold !== undefined
                    ? self.initData.version.targets[i].sampleTxt.bold
                    : self.initData.sampleTxt && self.initData.sampleTxt.bold !== undefined
                    ? self.initData.sampleTxt.bold
                    : false) === true
                    ? 'bold '
                    : '';
                text.font +=
                  (txt[iX].italic !== undefined
                    ? txt[iX].italic
                    : self.initData.version.targets[i].sampleTxt &&
                      self.initData.version.targets[i].sampleTxt.italic !== undefined
                    ? self.initData.version.targets[i].sampleTxt.italic
                    : self.initData.sampleTxt && self.initData.sampleTxt.italic !== undefined
                    ? self.initData.sampleTxt.italic
                    : false) === true
                    ? ' italic '
                    : '';
                text.font += txt[iX].size
                  ? txt[iX].size
                  : self.initData.version.targets[i].sampleTxt &&
                    self.initData.version.targets[i].sampleTxt.size !== undefined
                  ? self.initData.version.targets[i].sampleTxt.size
                  : self.initData.sampleTxt && self.initData.sampleTxt.size
                  ? self.initData.sampleTxt.size
                  : '20px';
                text.font += ' ';
                text.font += txt[iX].font
                  ? txt[iX].font
                  : self.initData.version.targets[i].sampleTxt &&
                    self.initData.version.targets[i].sampleTxt.font !== undefined
                  ? self.initData.version.targets[i].sampleTxt.font
                  : self.initData.sampleTxt && self.initData.sampleTxt.font
                  ? self.initData.sampleTxt.font
                  : 'Calibri';

                text.color =
                  txt[iX].color !== undefined
                    ? txt[iX].color
                    : self.initData.version.targets[i].sampleTxt &&
                      self.initData.version.targets[i].sampleTxt.color !== undefined
                    ? self.initData.version.targets[i].sampleTxt.color
                    : self.initData.sampleTxt && self.initData.sampleTxt.color
                    ? self.initData.sampleTxt.color
                    : 'black';

                text.textBaseline =
                  txt[iX].textBaseline !== undefined
                    ? txt[iX].textBaseline
                    : self.initData.version.targets[i].sampleTxt &&
                      self.initData.version.targets[i].sampleTxt.textBaseline !== undefined
                    ? self.initData.version.targets[i].sampleTxt.textBaseline
                    : self.initData.sampleTxt && self.initData.sampleTxt.textBaseline
                    ? self.initData.sampleTxt.textBaseline
                    : 'top';
                text.textAlign =
                  txt[iX].textAlign !== undefined
                    ? txt[iX].textAlign
                    : self.initData.version.targets[i].sampleTxt &&
                      self.initData.version.targets[i].sampleTxt.textAlign !== undefined
                    ? self.initData.version.targets[i].sampleTxt.textAlign
                    : self.initData.sampleTxt && self.initData.sampleTxt.textAlign
                    ? self.initData.sampleTxt.textAlign
                    : 'left';

                if (text.textAlign == 'center') text.x = contr.width / 2;
                else if (text.textAlign == 'right' || text.textAlign == 'end') text.x = contr.width;

                if (text.textBaseline == 'middle') text.y = contr.height / 2;
                else if (text.textBaseline == 'bottom') text.y = contr.height;

                text.x +=
                  item.posElem && Number.isInteger(item.posElem.x)
                    ? item.posElem.x
                    : self.initData.version.targets[i].sampleBgr &&
                      self.initData.version.targets[i].sampleBgr.posElem &&
                      Number.isInteger(self.initData.version.targets[i].sampleBgr.posElem.x)
                    ? self.initData.version.targets[i].sampleBgr.posElem.x
                    : self.initData.sampleBgr &&
                      self.initData.sampleBgr.posElem &&
                      Number.isInteger(self.initData.sampleBgr.posElem.x)
                    ? self.initData.sampleBgr.posElem.x
                    : 0;
                text.y +=
                  item.posElem && Number.isInteger(item.posElem.y)
                    ? item.posElem.y
                    : self.initData.version.targets[i].sampleBgr &&
                      self.initData.version.targets[i].sampleBgr.posElem &&
                      Number.isInteger(self.initData.version.targets[i].sampleBgr.posElem.y)
                    ? self.initData.version.targets[i].sampleBgr.posElem.y
                    : self.initData.sampleBgr &&
                      self.initData.sampleBgr.posElem &&
                      Number.isInteger(self.initData.sampleBgr.posElem.y)
                    ? self.initData.sampleBgr.posElem.y
                    : 0;

                text.lineHeight = Number.isInteger(txt[iX].lineHeight)
                  ? txt[iX].lineHeight
                  : self.initData.version.targets[i].sampleTxt &&
                    Number.isInteger(self.initData.version.targets[i].sampleTxt.lineHeight)
                  ? self.initData.version.targets[i].sampleTxt.lineHeight
                  : self.initData.sampleTxt && Number.isInteger(self.initData.sampleTxt.lineHeight)
                  ? self.initData.sampleTxt.lineHeight
                  : 0;
                text.lineWidth = Number.isInteger(txt[iX].lineWidth)
                  ? txt[iX].lineWidth
                  : self.initData.version.targets[i].sampleTxt &&
                    Number.isInteger(self.initData.version.targets[i].sampleTxt.lineWidth)
                  ? self.initData.version.targets[i].sampleTxt.lineWidth
                  : self.initData.sampleTxt && Number.isInteger(self.initData.sampleTxt.lineWidth)
                  ? self.initData.sampleTxt.lineWidth
                  : null;

                let yH =
                  self.initData.version.targets[i].sampleTxt &&
                  self.initData.version.targets[i].sampleTxt.pos &&
                  Number(self.initData.version.targets[i].sampleTxt.pos.h)
                    ? self.initData.version.targets[i].sampleTxt.pos.h
                    : 0;
                let pH =
                  self.initData.version.targets[i].sampleTxt &&
                  self.initData.version.targets[i].sampleTxt.pos &&
                  Number(self.initData.version.targets[i].sampleTxt.pos.padH)
                    ? self.initData.version.targets[i].sampleTxt.pos.padH
                    : 0;
                text.y += pH;
                text.y += yH * iX;

                if (
                  !(
                    (item.pos && Number.isInteger(item.pos.w)) ||
                    (self.initData.version.targets[i].pos !== undefined &&
                      Number.isInteger(self.initData.version.targets[i].pos.w))
                  ) &&
                  contr.width < text.getMeasuredWidth()
                ) {
                  console.log('ZMIANA: ' + text.getMeasuredWidth());
                  contr.width = text.getMeasuredWidth();
                  contr.width += text.x * 2;

                  let sh = contr.getChildByName('shape-bgr-color');
                  if (sh !== null) {
                    sh.graphics.c();
                    sh.width = contr.width;
                    if (contrSets.border && contrSets.border != 'transparent') {
                      sh.graphics.ss(contrSets.borderSize).s(contrSets.border);
                    }
                    sh.graphics.f(contrSets.color).dr(0, 0, sh.width, sh.height).ef();
                  }
                }

                if (contr.block !== true) {
                  text.listener = {
                    md: text.on('mousedown', self.stageMouseDown),
                    pu: text.on('pressup', self.stageMouseUp),
                  };
                }
                contr.addChildAt(text, contr.children.length);
                iX++;
              } while (txt[iX] !== undefined);

              self.images[i].push(contr);
              if (item.type != 'clone') {
                if (contr.point !== undefined) {
                  //   if ( self.initData.hideLine ) self.stage.addChild( contr.point, contr );
                  //   else self.stage.addChild( contr, contr.point );
                  if (self.initData.hideLine !== true) self.stage.addChild(contr);
                  contr.point.forEach(function (p) {
                    self.stage.addChild(p);
                  });
                  if (self.initData.hideLine === true) self.stage.addChild(contr);
                  contr.point.forEach(function (p) {
                    p.cache(-p.rad, -p.rad, p.rad * 2, p.rad * 2);
                  });
                } else self.stage.addChild(contr);
              } else {
                self.clones[i][item.origin].push(contr);
              }
            } else {
              if (item.sampleElem !== undefined || self.initData.version.targets[i].sampleElem !== undefined) {
                let hc =
                  item.hooksCount !== undefined && Number.isInteger(item.hooksCount)
                    ? item.hooksCount
                    : item.correct.length;
                for (let k = 0; k < hc; k++) {
                  var elem = false;
                  if (item.sampleElem !== undefined && item.sampleElem.elem !== undefined) {
                    item.sampleElem.elem.forEach(function (ic) {
                      if (ic.idC == k) {
                        elem = _.cloneDeep(ic);
                        elem.id = item.correct[k] + '-' + ic.idC;
                      }
                    });
                    if (elem === false && item.sampleElem.elem[k] !== undefined) {
                      elem = _.cloneDeep(item.sampleElem.elem[k]);
                      elem.id = undefined;
                    }
                  }
                  if (self.initData.version.targets[i].sampleElem !== undefined) {
                    self.initData.version.targets[i].sampleElem.elem.forEach(function (ic) {
                      if (ic.idC == k) {
                        if (elem === false) {
                          elem = _.cloneDeep(ic);
                          elem.id = item.correct[k] + '-' + ic.idC;
                        } else {
                          if (elem.color === undefined) elem.color = ic.color;
                          if (elem.border === undefined) elem.border = ic.border;
                          if (elem.borderSize === undefined) elem.borderSize = ic.borderSize;
                          if (elem.pos === undefined) elem.pos = ic.pos;
                        }

                        if (elem.id === undefined) {
                          elem.id = item.correct[k] + '-' + ic.idC;
                        }
                      }
                    });
                    if (self.initData.version.targets[i].sampleElem.elem[k] !== undefined) {
                      if (elem === false) {
                        elem = _.cloneDeep(self.initData.version.targets[i].sampleElem.elem[k]);
                      } else {
                        if (elem.color === undefined)
                          elem.color = self.initData.version.targets[i].sampleElem.elem[k].color;
                        if (elem.border === undefined)
                          elem.border = self.initData.version.targets[i].sampleElem.elem[k].border;
                        if (elem.borderSize === undefined)
                          elem.borderSize = self.initData.version.targets[i].sampleElem.elem[k].borderSize;
                        if (elem.pos === undefined) elem.pos = self.initData.version.targets[i].sampleElem.elem[k].pos;
                      }
                      if (
                        elem.id === undefined &&
                        self.initData.version.targets[i].sampleElem.elem[k].idC !== undefined
                      ) {
                        elem.id = item.correct[k] + '-' + self.initData.version.targets[i].sampleElem.elem[k].idC;
                      }
                    }
                    if (elem === false) elem = _.cloneDeep(self.initData.version.targets[i].sampleElem.elem[0]);
                    else {
                      if (elem.color === undefined)
                        elem.color = self.initData.version.targets[i].sampleElem.elem[0].color;
                      if (elem.border === undefined)
                        elem.border = self.initData.version.targets[i].sampleElem.elem[0].border;
                      if (elem.borderSize === undefined)
                        elem.borderSize = self.initData.version.targets[i].sampleElem.elem[0].borderSize;
                      if (elem.pos === undefined) elem.pos = self.initData.version.targets[i].sampleElem.elem[0].pos;
                    }
                  }
                  if (elem.id === undefined) elem.id = item.correct[k] + '-null';
                  if (elem.color === undefined)
                    elem.color =
                      item.sampleElem !== undefined && item.sampleElem.color !== undefined
                        ? item.sampleElem.color
                        : self.initData.version.targets[i].sampleElem !== undefined &&
                          self.initData.version.targets[i].sampleElem.color !== undefined
                        ? self.initData.version.targets[i].sampleElem.color
                        : 'transparent';
                  if (elem.border === undefined)
                    elem.border =
                      item.sampleElem !== undefined && item.sampleElem.border !== undefined
                        ? item.sampleElem.border
                        : self.initData.version.targets[i].sampleElem !== undefined &&
                          self.initData.version.targets[i].sampleElem.border !== undefined
                        ? self.initData.version.targets[i].sampleElem.border
                        : 'transparent';
                  if (elem.borderSize === undefined)
                    elem.borderSize =
                      item.sampleElem !== undefined && Number.isInteger(item.sampleElem.borderSize)
                        ? item.sampleElem.borderSize
                        : self.initData.version.targets[i].sampleElem !== undefined &&
                          Number.isInteger(self.initData.version.targets[i].sampleElem.borderSize)
                        ? self.initData.version.targets[i].sampleElem.borderSize
                        : 1;

                  let shape = new createjs.Shape();
                  shape.name = elem.id;
                  shape.width = elem.pos.w;
                  shape.height = elem.pos.h;
                  shape.x = Number.isInteger(elem.pos.x) ? elem.pos.x : 0;
                  shape.y = Number.isInteger(elem.pos.y) ? elem.pos.y : 0;
                  if (elem.border && elem.border != 'transparent') {
                    shape.graphics.ss(Number.isInteger(elem.borderSize) ? elem.borderSize : 1).s(elem.border);
                  }
                  shape.graphics.f(elem.color).dr(0, 0, shape.width, shape.height).ef();
                  if (elem.id) shape.id = elem.id;
                  shape.type = 'hook';
                  shape.block = false;

                  contr.addChild(shape);
                  contr.hooks.push(shape);
                }
              }
              self.images[i].push(contr);
              if (item.type != 'clone') {
                if (contr.point !== undefined) {
                  //      if ( self.initData.hideLine ) self.stage.addChild( contr.point, contr );
                  //      else self.stage.addChild( contr, contr.point );
                  if (self.initData.hideLine !== true) self.stage.addChild(contr);
                  contr.point.forEach(function (p) {
                    self.stage.addChild(p);
                  });
                  if (self.initData.hideLine === true) self.stage.addChild(contr);

                  contr.point.forEach(function (p) {
                    p.cache(-p.rad, -p.rad, p.rad * 2, p.rad * 2);
                  });
                } else self.stage.addChild(contr);
              } else self.clones[i][item.origin].push(contr);
            }
          }
        }
      }
      if (manifest.length > 0) {
        let queue = new preload.LoadQueue();
        queue.on('fileload', this.handleFileLoad);
        queue.on('complete', this.handleComplete);
        queue.loadManifest(manifest);
      } else this.maxClone += this.stage.numChildren;

      this.images.forEach(function (gr) {
        gr.forEach(function (cont) {
          cont.correct = self.findBmp(cont.correct);
        });
      });

      // if (!this.initData.hideLine) this.stage.addChild(this.line);
      this.stage.addChild(this.line);

      this.UnCacheStage(true);
    },
    initGame() {
      this.resetCheckStatus();
      this.setStage();

      var self = this;
      this.point = new createjs.Shape();
      let rad =
        this.initData.pointMouse && Number.isInteger(this.initData.pointMouse.rad) ? this.initData.pointMouse.rad : 8;
      this.point.graphics
        .beginFill(
          this.initData.pointMouse && this.initData.pointMouse.color !== undefined
            ? this.initData.pointMouse.color
            : 'rgba(0,0,0,0.3)'
        )
        .drawCircle(0, 0, rad);
      this.point.on('pressmove', function (e) {
        e.target.x = e.stageX - self.offset.x;
        e.target.y = e.stageY - self.offset.y;
        // self.update();
      });
      this.point.rad = rad;
      this.point.start = { gr: 0, i: 0 };
      this.point.visible = false;
      this.point.name = 'mousePoint';
      this.stage.addChild(this.point);
      this.point.cache(-rad, -rad, rad * 2, rad * 2);

      this.loadSamples();

      this.stage.setChildIndex(this.point, this.stage.getNumChildren() - 1);
    },
    newGame() {
      this.mousedown = false;
      this.stage.removeAllChildren();
      this.stage.removeAllEventListeners();

      this.targets.splice(0, this.targets.length);
      this.corrects.splice(0, this.corrects.length);
      this.movesTo.splice(0, this.movesTo.length);
      this.images.splice(0, this.images.length);
      this.clones.splice(0, this.clones.length);
      this.lines.splice(0, this.lines.length);

      this.initGame();
    },
    handleFileLoad(e) {
      var image = e.result;
      var w = image.width;
      var h = image.height;
      let bmp = new createjs.Bitmap(image.src);
      let cont = e.item.cont;

      bmp.id = cont.id;
      bmp.x = e.item.cord.x;
      bmp.y = e.item.cord.y;

      if (e.item.dim.w && e.item.dim.h) {
        bmp.scaleX = e.item.dim.w / w;
        bmp.scaleY = e.item.dim.h / h;
      } else if (e.item.dim.w && !e.item.dim.h) {
        bmp.scaleX = bmp.scaleY = e.item.dim.w / w;
      } else if (!e.item.dim.w && e.item.dim.h) {
        bmp.scaleX = bmp.scaleY = e.item.dim.h / h;
      }

      if (cont.block !== true) {
        bmp.listener = {
          md: bmp.on('mousedown', this.stageMouseDown),
          pu: bmp.on('pressup', this.stageMouseUp),
        };
      }
      cont.addChild(bmp);

      this.images[e.item.gr].push(cont);

      if (cont.type != 'clone') {
        if (cont.point !== undefined) {
          if (this.initData.hideLine) this.stage.addChild(cont.point, cont);
          else this.stage.addChild(cont, cont.point);
        } else this.stage.addChild(cont);
      } else {
        cont.cache(-cont.width, -cont.height, cont.width * 2, cont.height * 2);
        this.clones[e.item.gr][e.item.origin].push(cont);
      }
    },
    handleComplete(e) {
      var self = this;
      this.images.forEach(function (gr) {
        gr.forEach(function (cont) {
          cont.correct = self.findBmp(cont.correct);
        });
      });

      if (!this.initData.hideLine) this.stage.addChild(this.line);
      this.stage.setChildIndex(this.point, this.stage.getNumChildren() - 1);

      this.maxClone += this.stage.numChildren;
    },
    stageMouseDown(e) {
      console.log('DOWN');
    },
    stageMouseUp(e) {
      console.log('UP');
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        let x = this.moved.x + e.stageX - this.moved.stageX - this.offset.x;
        let y = this.moved.y + e.stageY - this.moved.stageY - this.offset.y;

        if (x <= -this.offset.x) x = -this.offset.x;
        else if (x + this.offset.x + this.moved.width > this.width) x = this.width - this.moved.width - this.offset.x;

        if (y <= -this.offset.y) y = -this.offset.y;
        else if (y + this.offset.y + this.moved.height > this.height)
          y = this.height - this.moved.height - this.offset.y;

        this.moved.x = x;
        this.moved.y = y;

        this.moved.stageX = e.stageX - this.offset.x;
        this.moved.stageY = e.stageY - this.offset.y;
      }
    },
    anim(bmp, move) {
      if (move.move) {
        let count = 20;

        if (Math.abs(bmp.x - move.x) < count) bmp.x = move.x;

        if (bmp.x < move.x) bmp.x += count;
        else if (bmp.x > move.x) bmp.x -= count;

        if (Math.abs(bmp.y - move.y) < count) bmp.y = move.y;

        if (bmp.y < move.y) bmp.y += count;
        else if (bmp.y > move.y) bmp.y -= count;
      }
    },
    removeListeners(a) {
      var self = this;
      if (a !== undefined) {
        if (Array.isArray(a) === false) {
          this.removeContListeners(a);
        } else {
          a.forEach(function (cont) {
            self.removeContListeners(cont);
          });
        }
      } else {
        this.images.forEach(function (gr) {
          gr.forEach(function (cont) {
            self.removeContListeners(cont);
          });
        });
      }
    },
    removeContListeners(cont) {
      if (cont.point !== undefined)
        cont.point.forEach(function (p) {
          if (p.listener.md !== undefined) p.off('mousedown', p.listener.md);
          if (p.listener.pu !== undefined) p.off('pressup', p.listener.pu);
          if (p.listener.c !== undefined) p.off('click', p.listener.c);
        });
      //      if ( cont.point !== undefined && cont.point.listener.md !== undefined ) cont.point.off( "mousedown", cont.point.listener.md );
      //      if ( cont.point !== undefined && cont.point.listener.pu !== undefined ) cont.point.off( "pressup", cont.point.listener.pu );
      //      if ( cont.point !== undefined && cont.point.listener.c !== undefined ) cont.point.off( "click", cont.point.listener.c );
      if (cont.listener.md !== undefined) cont.off('mousedown', cont.listener.md);
      if (cont.listener.pu !== undefined) cont.off('pressup', cont.listener.pu);
      if (cont.listener.c !== undefined) cont.off('click', cont.listener.c);
      cont.children.forEach(function (child) {
        if (child.listener !== undefined) {
          if (child.listener.md !== undefined) child.off('mousedown', child.listener.md);
          if (child.listener.pu !== undefined) child.off('pressup', child.listener.pu);
          if (child.listener.c !== undefined) child.off('click', child.listener.c);
        }
      });
    },
    beforeDestroy() {
      if (this.ticker !== false) this.ticker.removeAllEventListeners();
      this.UnCacheStage(false);
      this.stage.removeAllEventListeners();
    },
    findBmp(cor) {
      if (cor === undefined) return false;
      var finds = [];
      for (let i = 0; i < this.images.length; i++) {
        for (let j = 0; j < this.images[i].length; j++) {
          for (let k = 0; k < cor.length; k++) {
            if (this.images[i][j].id == cor[k]) finds.push(Object.assign({ gr: i, i: j, id: cor[k] }));
          }
        }
      }
      return finds;
    },
  },
  computed: {},
  watch: {},
};
